import styled, { css } from 'styled-components';

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MainContainer = styled(Column)`
  width: 600px;
  height: 300px;
`;

export const UploadArea = styled.div<{ dragging: boolean }>`
  background-color: ${({ theme }) => theme.uploadArea};;
  border-radius: .5rem;
  padding: .5rem;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  ${({ dragging }) => dragging && css`filter: brightness(60%);`};
`;

export const UploadBorder = styled(Column)`
  border: 2px dashed ${({ theme }) => theme.grey};
  align-items: center;
  padding: 2rem;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  & > span {
    font-size: 18px;
  };
  & svg {
    height: 22px;
    width: 22px;
  }
`;

export const UploadOpts = styled(Column)`
  margin-top: 10px;
  & button {
    margin: 0 auto;
  };
  & span {
    font-size: 12px;
  };
`;

export const FileInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  & span {
    font-size: 16px;
  }
  & .errorMsg {
    color: ${({ theme }) => theme.error};
  }
`;

export const FileInfo = styled(Row)`
  padding: 5px;
  background-color: ${({ theme }) => theme.container};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.containerHover};
  justify-content: center;
  align-items: center;
  gap: 5px;
    
  & svg {
    height: 20px;
    fill: ${({ theme }) => theme.primary};
  }
`;
